import React from "react"


import Layout from "../components/layout";
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import AdminBenefits from "../components/benefitAdmin";
import MembersBenefits from "../components/benefitsMembers";
import ContactForm from "../components/contactForm";

import { withTranslation  } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import LayoutLandingPage from "../components/layoutLandingPage";
import BlendingBox from "../components/blendingBox"

const useStyle = makeStyles({
    card: {
      maxWidth: 345,
      margin: "10px",
      borderRadius:16,
    },
    media: {
      height: 140,
    },
    box:{
      height: 400,
    },
    overlap:{
        marginLeft: 40,
        paddingTop: 100
    }
  });

function Index({t, i18n}){
  let classes = useStyle();

  return (
    <LayoutLandingPage className={classes.root}>
         
            <Box className={classes.box}
            css={{backgroundImage: `url('images/Altendorf.jpg')`,
                  backgroundPosition: 'center',
                  marginRight: 'auto'}}
            
            >
            <Box className = {classes.overlap}>
              <Typography variant="h3" color="textSecondary"
               >
                {t('slogan')}
              </Typography>
            
              <br/>
              
              <Typography variant="h5" color="textSecondary">
                 {t('subtitle')}
              </Typography>
            </Box>
              
        </Box>
     
    
      <BlendingBox/>
      <AdminBenefits/>
      <MembersBenefits/>
      <ContactForm/>
     
    </LayoutLandingPage>
  )
}

export default withTranslation('landing') (Index)